/**
 * Created by Ali Ahsen Mir on 8/11/2016.
 */

(function () {

    angular.module('tmx-app').factory('DashboardService', ['tmxResource', '$q','cacheStore','$timeout',
        function DashCtrl(tmxResource, $q,cacheStore,$timeout) {
            var Dashboard = tmxResource("Dashboard");

            Dashboard.getCurrentUserApplications = function () {
                var deferred = $q.defer();

                Dashboard.getByAction("GetApplicationsByUser", true).then(function (response) {
                    if (response) {
                        deferred.resolve(response);
                    }
                    else {
                        deferred.reject("Unable to load user data");
                    }
                });
                return deferred.promise;
            }
           
            Dashboard.GetPendingAppDetails = function (branchId) {
                var deferred = $q.defer();
                Dashboard.getByAction("GetPendingAppDetails/" + branchId, true).then(function (response) {
                    if (response) {
                        var parsedResponse = [];
                        response.forEach(element => {
                            var parsedResponseElement = parsedResponse.find(function (x) { return x.ApplicationNumber == element.ApplicationNumber });
                            if (parsedResponseElement) {
                                if (element.Comments) {
                                    parsedResponseElement.Comments = parsedResponseElement.Comments ? parsedResponseElement.Comments + '\n\r' + element.Comments : element.Comments;
                                }
                            }
                            else {
                                parsedResponse.push(element);
                            }
                        });
                        deferred.resolve(parsedResponse);
                    }
                    else {
                        deferred.reject('Unable to load Pending apps');
                    }
                });
                return deferred.promise;
            }

            Dashboard.GetChronicAppDetails = function(branchId) {
                var deferred = $q.defer();
                Dashboard.getByAction("GetChronicAppDetails/" + branchId, true).then(function (response) {
                    if (response) {
                        deferred.resolve(response);
                    }
                    else {
                        deferred.reject('Unable to load Chronic apps');
                    }
                });
                return deferred.promise;
            }
            Dashboard.GetBIReports = function() {
                var deferred = $q.defer();
                var reportModel = cacheStore.get('PowerBIReportModel');
                if (reportModel) {
                    $timeout(function(){
                        deferred.resolve(reportModel);
                    });
                }
                else{
                    tmxResource("PowerBIReports").getByAction('GetBIReports', false).then(function (promise) {  
                        if (promise) {
                            cacheStore.set('PowerBIReportModel', promise);
                            deferred.resolve(promise);
                        }
                        else {
                            deferred.reject("Unable to load reports");
                        }
                    });
                }
                return deferred.promise;
            }
            return Dashboard;
        }]);
        
})();